module.exports = __webpack_public_path__ + "static/media/6S.480b9ece.svg";